
import { useState, useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import axios from 'axios'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import 'bootstrap/dist/css/bootstrap.min.css'
import "yet-another-react-lightbox/styles.css"
import './App.css'

import { Whatsapp } from 'react-bootstrap-icons';

import logo from './img/logo.jpg'

import medal01 from './img/medal01.jpg'
import medal02 from './img/medal02.jpg'
import medal03 from './img/medal03.jpg'
import medal04 from './img/medal04.jpg'

import g2 from './img/carrera/g2.jpg'
import g3 from './img/carrera/g3.jpg'
import g4 from './img/carrera/g4.jpg'
import g9 from './img/carrera/g9.jpg'
import g10 from './img/carrera/g10.jpg'
import oed from './img/oed.jpg'
import m1 from './img/m01.jpg'
import m2 from './img/m02.jpg'
import m3 from './img/m03.jpg'
import collage from './img/collage.jpg'

const API_PATH = "https://somosglotones.com/srv/api/euk/sendChronosMail";
const SITE_KEY = "6LdaWaUrAAAAALkcZL5pXVO3CyzL6EPJE4QJLitE";

function SinExcusas({ refContact, handleClick }) {
  const targetDate = "2026-05-01T00:00:00"

  const [isLoading, setLoading] = useState(false)
  const [firstName, setFirstName] = useState("")
  const [, setName] = useState("")
  const [lastName, setLastName] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [comments, setComments] = useState("")

  const [showMessage, setShowMessage] = useState(false)
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')

  const [timeLeft, setTimeLeft] = useState(0);

  const handleShow = () => setShowMessage(true);

  useEffect(() => {
    calculateTimeLeft()

    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    }

    // load the script by passing the URL
    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
      console.log("Script loaded!");
    });
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer); // limpiar intervalo al desmontar 
  }, [targetDate]);

  const handleOnChange = (event) => {
    var inputName = "set" + event.target.name.charAt(0).toUpperCase() + event.target.name.slice(1);
    eval(inputName)(event.target.value)
  }

  const handleOnSubmit = (event) => {
    event.preventDefault();

    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then(token => {
        //if(isVerified){
        setLoading(true);
        //const recaptchaValue = recaptchaRef.current.getValue();
        var form = document.getElementById("contactForm");
        var formData = new FormData(form);
        formData.append('name', firstName + " " + lastName);
        formData.append('recaptcha_response', token);

        setLoading(true);
        axios.post(API_PATH, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function (response) {

          if (response.data === "FAIL" || response.data === "ERROR") {
            setLoading(false)
            setTitle("Error")
            setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
            handleShow()
          } else {
            setLoading(false)
            setTitle("Mensaje enviado")
            setMessage("Tu mensaje ha sido enviado. En breve nos comunicaremos contigo. Gracias.");
            handleShow()

            setName("");
            setFirstName("")
            setLastName("")
            setPhone("");
            setEmail("");
            setComments("");
          }

        }).catch(function (err) {
          setLoading(false)
          setTitle("Error")
          setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
          handleShow()
        });
        //} else 
        //alert("Por favor, verifica que no eres un robot")
      });
    });
  }

  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = { days: Math.floor(difference / (1000 * 60 * 60 * 24)), hours: Math.floor((difference / (1000 * 60 * 60)) % 24), minutes: Math.floor((difference / 1000 / 60) % 60), seconds: Math.floor((difference / 1000) % 60), };
    }

    return timeLeft;
  };

  const prices = [
    {
      title: 'SÁBADOS Y DOMINGOS',
      desc: 'Mejorar marcas y ritmos + desarrollar tu físico + mejorar técnica',
      price: '$500',
      promo: '$500',
      points: ['Sábado y Domingo', 'Ajustes específicos e informe comparativo de progreso', 'Plan Mensual enfocado a objetivos', 'Uniforme Gratis al cumplir 10 semanas'],
      img: oed
    },
    {
      title: 'LUNES, MIÉRCOLES Y VIERNES',
      desc: 'Bajar de peso + crear hábitos + disciplina',
      price: '$600',
      promo: '$600',
      points: ['Sábado y Domingo', 'Tareas Semanales', 'Uniforme Gratis al cumplir 10 semanas'],
      img: m3
    },
    {
      title: 'LUNES, MIÉRCOLES, VIERNES, SÁBADO Y DOMINGO',
      desc: 'Atletas y Adultos que buscan rendimiento medible, técnica depurada y un servicio premium basado en ciencia',
      price: '$750',
      promo: '$750',
      points: ['Sábado y Domingo', 'Seguimiento prioritario + informe de rendimiento + lectura técnica', 'Planificación personalizada', 'Uniforme y playera de entrenamiento gratis al cumplir 10 semanas', 'Evaluación trimestral de velocidad, fuerza, resistencia, flexibilidad y biomecánica de carrera'],
      img: g4
    }
  ]

  const packs = [
    {
      title: 'Fundamentos',
      desc: 'Técnica de carrera + trabajo principal + acondicionamiento físico',
      img: g3
    },
    {
      title: 'Técnica y Progresión',
      desc: 'Correcciones en ejecución + fundamentos técnicos + base aeróbica',
      img: g2
    },
    {
      title: 'Tu Rutina Flexible',
      desc: 'Realiza ctividades a tu ritmo, en el horario de tu elección, sin presión',
      img: m1
    }
  ]

  const points = ['Entrena y baja de peso con estructura (no con improvisación)', 'Técnica + condición + comunidad', 'Progreso medible semana a semana']

  return (
    <div>
      <Modal show={showMessage} onHide={() => setShowMessage(false)}>
        <Modal.Header style={{ background: "#fff" }} closeButton>
          <Modal.Title style={{ color: "#000" }}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ color: "#000", background: "#fff" }}>{message}</Modal.Body>
        <Modal.Footer style={{ color: "#000", background: "#fff" }}>
          <Button aria-label="Aceptar" variant="secondary" onClick={() => setShowMessage(false)}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      <div className='promo-container'>
        <Container>
          <Row>
            <Col></Col>
            <Col md={7} xs={12}>
              <div align={isMobile ? "center" : "right"}>
                <div> <img alt="" width="auto" height="auto" src={logo} className='logo-promo' /> </div>
                <br /><br />

                <div align={isMobile ? "center" : "right"}>
                  <div className='promo-title'>¡Llévate tu playera de</div>
                  <div className='promo-title-alt'>ENTRENAMIENTO</div>

                  <div className='promo-title promo-title-big'> GRATIS
                    {/*{isMobile && <br />}
                    <span className='promo-title promo-title-small'>.00 </span>*/}
                  </div>
                  <div className='promo-title'> al inscribirte hoy!</div>
                </div>
                <br /><br />

                <div align="center">
                  <span className='promo-time'>
                    <div>
                      <div className='promo-content'> ¡No dejes pasar esta promo! </div>
                      <div className='promo-content-small'>Reclama la tuya</div>
                    </div>
                  </span>
                </div>
                <br />
                {/*<div className='promo-counter'> {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s </div>
                <br /><br /><br />
                <div align="center" onClick={() => handleClick('refContact')}>
                  <span className='promo-text-btn'> ¡Quiero Unirme! </span>
                </div>*/}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className='section-black'>
        <Container>
          <Row className='align-items-center'>
            {isMobile &&
              <Col xs={12}>
                <div align="center" className='promo-title'>Tu guía completa de entrenamiento</div>
                <div className='pack-space'></div>
              </Col>
            }
            <Col md={8}>
              <Container>
                <Row>
                  {packs.map(item => (
                    <Col md={4} xs={12} style={{ paddingBottom: '15px' }}>
                      <div className=''>
                        <div className='pack-title'>{item.title}</div>
                        <br />
                        <div className='pack-desc'>{item.desc}</div>
                        <br />
                        <div className='promo-img-pack-container' style={{ backgroundImage: 'url(' + item.img + ')' }} />
                      </div>
                    </Col>
                  ))}
                </Row>
              </Container>
            </Col>
            {!isMobile &&
              <Col md={4}>
                <div align="center" className='promo-title'>Incluído en todos los niveles</div>
                <div className='pack-space'></div>
              </Col>
            }
          </Row>
        </Container>
      </div>

      <div className='section-black'>
        <Container>
          <Row className='align-items-center'>
            <Col md={7}>
              <div align={isMobile ? "center" : "left"} className='promo-title'>Agenda tu sesión de entrenamiento de cortesía y siente la energía de la comunidad</div>
              <br />
              <Container>
                <Row>
                  <Col md={6}> <div className='promo-img-container' style={{ backgroundImage: 'url(' + g10 + ')' }} /> </Col>
                  <Col md={6}> <div className='promo-img-container' style={{ backgroundImage: 'url(' + m2 + ')' }} /> </Col>
                </Row>
              </Container>
            </Col>
            <Col md={5}>
              {points.map(item => (
                <div className='pack-title-alt' style={{ padding: '20px 10px' }}>{item}</div>
              ))}
            </Col>
          </Row>
        </Container>
      </div>

      <div className='section-black'>
        <div align="center" className='promo-title'>Elige tu paquete Chronos</div>
        <br /><br />

        <Container>
          <Row>
            {prices.map(item => (
              <Col md={4} xs={12} style={{ paddingBottom: '15px', display: 'flex' }}>
                <div className='price-container' style={{ background: "linear-gradient( rgba(45, 45, 45, 0.9), /* capa oscura */ rgba(45, 45, 45, 0.9) ), url('" + item.img + "')" }}>
                  <div className='promo-price-title'>{item.title}</div>
                  <br />
                  <div className='promo-price-desc'>{item.desc}</div>
                  <br />
                  <div className='promo-price-normal'>Mensual</div>
                  <br />
                  <div align="center">
                    {/*<div className='promo-price-price-alt' style={{ textDecoration: 'line-through', fontSize: '35px', lineHeight: '35px' }}>&nbsp;&nbsp;{item.price}&nbsp;&nbsp;</div>*/}
                    <div className='promo-price-price-alt'>{item.price}</div>
                  </div>
                  <br />
                  {/*<div align="left">
                    <ul>
                      {item.points.map(point => (
                        <li className='promo-price-list'>{point}</li>
                      ))}
                    </ul>
                  </div>*/}
                  <br /> <br />
                  <div align="center" className="promo-price-footer" onClick={() => handleClick('refContact')}>
                    <span className='promo-price-btn'> ¡Me Interesa! </span>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      <div className='section-black'>
        <Container>
          <Row>
            {!isMobile &&
              <Col md={6}>
                <Container>
                  <Row>
                    <Col md={6} xs={12}> <div className='promo-img-pack-container' style={{ backgroundImage: 'url(' + medal01 + ')' }} /> </Col>
                    <Col md={6} xs={12}> <div className='promo-img-pack-container' style={{ backgroundImage: 'url(' + medal02 + ')' }} /> </Col>
                    <Col md={6} xs={12}> <div className='promo-img-pack-container' style={{ backgroundImage: 'url(' + medal03 + ')' }} /> </Col>
                    <Col md={6} xs={12}> <div className='promo-img-pack-container' style={{ backgroundImage: 'url(' + medal04 + ')' }} /> </Col>
                  </Row>
                </Container>
              </Col>
            }
            <Col md={6}>
              <div align="center">
                <div align="center" className='promo-title'>Resultados reales, método real</div>
                <br /><br />
              </div>
              <Container>
                <Row className='align-items-center'>
                  <div>
                    <br />
                    <div className='promo-desc' style={{ fontWeight: 'bold' }}> Yaretzi Robles </div>
                    <br />
                    <div className='home-desc home-author'> 1ª lugar Relevo Femenil 4x75 mts JDEEB CDMX </div>
                    <div className='home-desc home-author'> 1º lugar Lanzamiento de Pelota JDEEB CDMX </div>
                    <br /><br />

                    <div className='promo-desc' style={{ fontWeight: 'bold' }}> Valentín Espinosa </div>
                    <br />
                    <div className='home-desc home-author'> 2ª lugar Running Series Fecha 10 Zona GNP Sports </div>
                    <br /><br />

                    <div className='promo-desc' style={{ fontWeight: 'bold' }}> Iker Suárez </div>
                    <br />
                    <div className='home-desc home-author'> 1º lugar Salto de Longitud IX Encuentro Invernal de Atletismo 2025 </div>
                    <div className='home-desc home-author'> 1º lugar 300 mts IX Encuentro Invernal de Atletismo 2025 </div>
                    <div className='home-desc home-author'> 2º lugar Salto de Longitud Juegos Deportivos Infantiles y Juveniles de la CDMX </div>
                  </div>
                </Row>
              </Container>
            </Col>
            {isMobile &&
              <Col md={6}>
                <br /><br />
                <Container>
                  <Row>
                    <Col md={6} xs={12}> <div className='promo-img-container' style={{ backgroundImage: 'url(' + medal01 + ')' }} /> </Col>
                    <Col md={6} xs={12}> <div className='promo-img-container' style={{ backgroundImage: 'url(' + medal02 + ')' }} /> </Col>
                    <Col md={6} xs={12}> <div className='promo-img-container' style={{ backgroundImage: 'url(' + medal03 + ')' }} /> </Col>
                    <Col md={6} xs={12}> <div className='promo-img-container' style={{ backgroundImage: 'url(' + medal04 + ')' }} /> </Col>
                  </Row>
                </Container>
              </Col>
            }
          </Row>
        </Container>
      </div>

      <div className='section-black'>
        <Container>
          <Row className='align-items-center'>
            <Col md={6}>
              <div align="center">
                <span className='promo-time'>
                  <div>
                    <div className='pack-title-alt' style={{ color: '#000', fontStyle: 'normal', transform: 'skewX(20deg)' }}>
                      Transforma tu constancia
                    </div>
                  </div>
                </span>
              </div>
              <br />
              <div className='promo-discount'> ALCANZA TUS METAS DE FORMA SEGURA </div>
              <br />
              <div className='promo-desc' align="center"> Entrena con un método basado en ciencia y respaldado por la experiencia. </div>
              <br /><br /><br />
              <div align="center" onClick={() => handleClick('refContact')}>
                <span className='promo-text-btn'> ¡Quiero Unirme! </span>
              </div>
            </Col>
            <Col md={6}>
              {isMobile && <div style={{ paddingTop: '50px' }}></div>}
              <div className='promo-img-pack-container' style={{ backgroundImage: 'url(' + g9 + ')' }} />
            </Col>
          </Row>
        </Container>
      </div>

      <div className='section-contact' ref={refContact}>
        <div align="center">
          <Container>
            <Row className='align-items-center'>
              {!isMobile && <Col md={6}>
                <img src={collage} className='us-image' />
              </Col>
              }
              <Col md={6} xs={12}>
                <div className='promo-contact-title'> ¡No lo pienses más! </div>
                <div className='promo-contact-title-alt'> Comienza la mejor versión de ti mismo </div>
                <div className='promo-contact-title-alt' style={{ color: '#eccc29', paddingTop: '15px' }}> Agenda tu sesión de entrenamiento GRATUITO hoy mismo </div>
                <br />
                <div className='promo-price-desc' style={{ color: '#000' }}>Dejanos tus datos de contacto y nos contactaremos contigo a la brevedad o vía Whatsapp al número <span className={'text-footer'} style={{ color: '#000' }} onClick={() => window.open('https://wa.me/525534231536', '_blank')}> <Whatsapp style={{ top: '-1px', position: 'relative' }} /> 55 3423 1536 </span> </div>

                <div className='promo-form'>
                  <Form id="contactForm" onSubmit={handleOnSubmit}>
                    <Container>
                      <Row>
                        <Col md={6} xs={12}>
                          <Form.Group controlId="formGridEmail" className='mb-3'>
                            <Form.Control required name="firstName" value={firstName} placeholder="Nombre:" onChange={handleOnChange} />
                          </Form.Group>
                        </Col>
                        <Col md={6} xs={12}>
                          <Form.Group controlId="formGridEmail" className='mb-3'>
                            <Form.Control required name="lastName" value={lastName} placeholder="Apellido:" onChange={handleOnChange} />
                          </Form.Group>
                        </Col>
                        <Col md={6} xs={12}>
                          <Form.Group controlId="formGridEmail" className='mb-3'>
                            <Form.Control required type="number" value={phone} name="phone" placeholder="Teléfono:" onChange={handleOnChange} />
                          </Form.Group>
                        </Col>
                        <Col md={6} xs={12}>
                          <Form.Group controlId="formGridEmail" className='mb-3'>
                            <Form.Control required type="email" value={email} name="email" placeholder="Correo Electrónico:" onChange={handleOnChange} />
                          </Form.Group>
                        </Col>
                        <Col md={12} xs={12}>
                          <Form.Group controlId="formGridEmail" className='mb-3'>
                            <Form.Control required name="comments" as="textarea" value={comments} rows="4" placeholder="Mensaje:" onChange={handleOnChange} />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <div>
                          <br />
                          <div align="center"><Button aria-label="Enviar" disabled={isLoading} className="form-button" type="submit" >{isLoading ? 'Enviando…' : 'ENVIAR'}</Button></div>
                        </div>
                      </Row>
                    </Container>
                  </Form>
                </div>
              </Col>
              {isMobile && <Col xs={12}>
                <div style={{ paddingTop: '30px' }}>  <img src={collage} className='us-image' /></div>
              </Col>
              }
            </Row>
          </Container>
        </div>

      </div>

    </div>
  );
}

export default SinExcusas;